import React, { FunctionComponent, useEffect } from 'react';
import { Card } from '../../../ui';
import { useHistory } from 'react-router-dom';
import { signOut } from '../../../../hooks/useAuth';
import { useSession } from '../../../../state/app-state';
import { Session } from '../../../../services/models/session';

const SignOutPage: FunctionComponent = () => {
  const session = useSession();
  const history = useHistory();

  useEffect(() => {
    if (session?.token || session?.account) {
      signOut();
    } else {
      history.push('/');
    }
  }, [session, history, signOut]);

  return (
    <Card>
      <Card.Body className="text-center">Signing out...</Card.Body>
    </Card>
  );
};

export default SignOutPage;
